import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'recordingModals.extension.banner.description':
    'Record straight from your browser without opening Rask, and get dynamic auto-zoom on every click.',
  'recordingModals.extension.banner.title': 'Record even faster with the Rask extension',
  'recordingModals.extension.closeAria': 'Close extension setup',
  'recordingModals.extension.install.addToChrome': 'Add to Chrome',
  'recordingModals.extension.install.cardKind': 'Chrome extension',
  'recordingModals.extension.install.cta': 'Install extension',
  'recordingModals.extension.install.description':
    'Auto-zooms are added while you record. Install the Rask Chrome extension to turn them on.',
  'recordingModals.extension.install.title': 'Install the extension to get auto-zooms',
  'recordingModals.extension.pin.cta': 'Record video',
  'recordingModals.extension.pin.description':
    'Click the pin to keep Rask in your toolbar, then click the Rask icon to run it and start recording — auto-zooms follow your clicks automatically.',
  'recordingModals.extension.pin.extensions': 'Extensions',
  'recordingModals.extension.pin.installed': 'Extension installed',
  'recordingModals.extension.pin.title': 'Pin Rask to access later',
  'recordingModals.extension.recorderName': 'Rask Screen Recorder',
  'recordingModals.intro.paid.description':
    "Record your screen and we'll turn it into a polished product demo - cutting the filler, pauses and stumbles for you.",
  'recordingModals.intro.trial.badge': 'TRIAL · 1 FREE VIDEO',
  'recordingModals.intro.trial.description':
    "Record your screen and we'll turn it into a polished product demo - cutting the filler, pauses and stumbles for you. Your trial includes 1 video, up to {minutes} minutes.",
  'recordingModals.paywall.autoZoom.badge': 'AVAILABLE ON ALL PLANS',
  'recordingModals.paywall.autoZoom.bullet1': "Guide viewers straight to the feature you're showing",
  'recordingModals.paywall.autoZoom.bullet2': 'Make small UI details clear on any screen',
  'recordingModals.paywall.autoZoom.bullet3': 'Highlight every click so nothing gets missed',
  'recordingModals.paywall.autoZoom.description':
    'Rask zooms in on every click automatically. Your demo looks produced, and viewers always look where it matters.',
  'recordingModals.paywall.autoZoom.preview.badge': 'Auto zoom',
  'recordingModals.paywall.autoZoom.preview.cta': 'Get started',
  'recordingModals.paywall.autoZoom.strip': 'Screen recordings that watch like a produced demo.',
  'recordingModals.paywall.autoZoom.title': 'Dynamic zoom, added for you',
  'recordingModals.paywall.choosePlan': 'Choose plan',
  'recordingModals.paywall.closeAria': 'Close paywall modal',
  'recordingModals.paywall.download.badge': 'AVAILABLE ON ALL PLANS',
  'recordingModals.paywall.download.bullet1': 'Full-length demo in high quality',
  'recordingModals.paywall.download.bullet2': 'Export a clean MP4, branded entirely as yours',
  'recordingModals.paywall.download.bullet3': 'Publish anywhere or send the file to your team',
  'recordingModals.paywall.download.description':
    'A paid plan exports your finished demo in full quality, ready to publish and share.',
  'recordingModals.paywall.download.preview.alt': 'Video demo preview',
  'recordingModals.paywall.download.preview.button': 'Download video',
  'recordingModals.paywall.download.strip': 'The complete result - exactly what you made.',
  'recordingModals.paywall.download.title': 'Your demo is ready.\nDownload it in full',
  'recordingModals.paywall.recordingMinutes.badge': 'FREE RECORDING USED',
  'recordingModals.paywall.recordingMinutes.bullet1': 'Record as many demos as you need',
  'recordingModals.paywall.recordingMinutes.bullet2': 'Let AI clean up every recording',
  'recordingModals.paywall.recordingMinutes.bullet3': 'Add dynamic zoom that follows the action',
  'recordingModals.paywall.recordingMinutes.description':
    "You've used your free recording. Upgrade to keep going and record unlimited product demos, cleaned up by AI.",
  'recordingModals.paywall.recordingMinutes.preview.rec': 'REC {time}',
  'recordingModals.paywall.recordingMinutes.strip': 'Unlimited demos, start to finish.',
  'recordingModals.paywall.recordingMinutes.title': 'Keep turning your screen into polished demos',
  'recordingModals.paywall.translateMinutes.badge': 'UPGRADE FOR MORE MINUTES',
  'recordingModals.paywall.translateMinutes.bullet1': 'Speak to viewers in 135+ languages',
  'recordingModals.paywall.translateMinutes.bullet2': 'Keep your own voice in every language',
  'recordingModals.paywall.translateMinutes.bullet3': 'Turn one video into a library of localized versions',
  'recordingModals.paywall.translateMinutes.description':
    'Upgrade to keep translating your videos into 135+ languages with natural, native-sounding voices.',
  'recordingModals.paywall.translateMinutes.preview.caption': 'Translating demo video',
  'recordingModals.paywall.translateMinutes.strip': 'One video, ready for every market.',
  'recordingModals.paywall.translateMinutes.title': 'Reach every audience in their language',
  'recordingModals.recorder.ariaLabel': 'Screen recorder',
  'recordingModals.recorder.camera': 'Camera',
  'recordingModals.recorder.cameraFallback': 'Camera {index}',
  'recordingModals.recorder.cameraUnavailable': 'Camera is unavailable. Recording without camera.',
  'recordingModals.recorder.close': 'Close recorder',
  'recordingModals.recorder.defaultTitle': 'Screen recording {date}',
  'recordingModals.recorder.delete.cancel': 'Cancel',
  'recordingModals.recorder.delete.closeAria': 'Close delete confirmation',
  'recordingModals.recorder.delete.confirm': 'Delete',
  'recordingModals.recorder.delete.description': "The recording won't be saved. You can start again anytime.",
  'recordingModals.recorder.delete.title': 'Delete this recording?',
  'recordingModals.recorder.desktopOnly': 'Screen recording is available on desktop only',
  'recordingModals.recorder.discard': 'Discard recording',
  'recordingModals.recorder.duration': 'Recording time',
  'recordingModals.recorder.error.cancelled':
    'Screen sharing was cancelled. Choose a screen, window, or tab to start recording.',
  'recordingModals.recorder.error.generic': 'Could not start screen recording. Please try again.',
  'recordingModals.recorder.error.sharingEnded':
    'Screen sharing ended before the recording could start. Please try again.',
  'recordingModals.recorder.microphone': 'Microphone',
  'recordingModals.recorder.microphoneFallback': 'Microphone {index}',
  'recordingModals.recorder.microphoneUnavailable': 'Microphone is unavailable. Recording without microphone.',
  'recordingModals.recorder.noCamera': "Don't record camera",
  'recordingModals.recorder.noCameraOption': "Don't record camera",
  'recordingModals.recorder.noMicrophone': "Don't record mic",
  'recordingModals.recorder.noMicrophoneOption': "Don't record microphone",
  'recordingModals.recorder.pause': 'Pause recording',
  'recordingModals.recorder.reconnecting': 'Reconnecting…',
  'recordingModals.recorder.record': 'Record',
  'recordingModals.recorder.resume': 'Resume recording',
  'recordingModals.recorder.saveFailed.accessDenied':
    "You can't save recordings in this Teamspace right now. Ask its owner to check the plan and your access.",
  'recordingModals.recorder.saveFailed.autoStopped':
    "Recording stopped because it couldn't be uploaded. What you've recorded so far is still available, so you can try saving it again.",
  'recordingModals.recorder.saveFailed.delete': 'Delete',
  'recordingModals.recorder.saveFailed.retry': 'Retry',
  'recordingModals.recorder.saveFailed.title': "Couldn't save the recording",
  'recordingModals.recorder.saving': 'Saving recording…',
  'recordingModals.recorder.stop': 'Stop recording',
  'recordingModals.share.button': 'Share',
  'recordingModals.share.closeAria': 'Close share modal',
  'recordingModals.share.copy': 'Copy',
  'recordingModals.share.description': 'Copy the link and send it to anyone.',
  'recordingModals.share.linkAria': 'Share link',
  'recordingModals.share.linkCopied': 'Link copied to clipboard',
  'recordingModals.share.title': 'Your demo is ready to share',
  'recordingModals.share.upsell': 'Share full-length, watermark-free demos',
} as const;

type RecordingModalsTranslation = Record<keyof typeof en, string>;

const es = {
  'recordingModals.extension.banner.description':
    'Graba directamente desde tu navegador sin abrir Rask y consigue un zoom automático dinámico en cada clic.',
  'recordingModals.extension.banner.title': 'Graba aún más rápido con la extensión de Rask',
  'recordingModals.extension.closeAria': 'Cerrar la configuración de la extensión',
  'recordingModals.extension.install.addToChrome': 'Añadir a Chrome',
  'recordingModals.extension.install.cardKind': 'Extensión de Chrome',
  'recordingModals.extension.install.cta': 'Instalar extensión',
  'recordingModals.extension.install.description':
    'Los zooms automáticos se añaden mientras grabas. Instala la extensión de Rask para Chrome para activarlos.',
  'recordingModals.extension.install.title': 'Instala la extensión para activar los zooms automáticos',
  'recordingModals.extension.pin.cta': 'Grabar vídeo',
  'recordingModals.extension.pin.description':
    'Haz clic en el icono de la chincheta para mantener Rask en la barra de herramientas y, después, haz clic en el icono de Rask para abrirlo y empezar a grabar: los zooms automáticos siguen tus clics automáticamente.',
  'recordingModals.extension.pin.extensions': 'Extensiones',
  'recordingModals.extension.pin.installed': 'Extensión instalada',
  'recordingModals.extension.pin.title': 'Fija Rask para tenerlo a mano',
  'recordingModals.extension.recorderName': 'Rask Screen Recorder',
  'recordingModals.intro.paid.description':
    'Graba tu pantalla y convertiremos la grabación en una demo de producto impecable, eliminando por ti las muletillas, las pausas y los titubeos.',
  'recordingModals.intro.trial.badge': 'PRUEBA · 1 VÍDEO GRATIS',
  'recordingModals.intro.trial.description':
    'Graba tu pantalla y convertiremos la grabación en una demo de producto impecable, eliminando por ti las muletillas, las pausas y los titubeos. Tu prueba incluye 1 vídeo de hasta {minutes} minutos.',
  'recordingModals.paywall.autoZoom.badge': 'DISPONIBLE EN TODOS LOS PLANES',
  'recordingModals.paywall.autoZoom.bullet1': 'Guía la mirada del público directamente a la función que muestras',
  'recordingModals.paywall.autoZoom.bullet2':
    'Haz que los pequeños detalles de la interfaz se vean con claridad en cualquier pantalla',
  'recordingModals.paywall.autoZoom.bullet3': 'Resalta cada clic para que no se pierda nada',
  'recordingModals.paywall.autoZoom.description':
    'Rask hace zoom en cada clic automáticamente. Tu demo luce profesional y el público siempre mira donde importa.',
  'recordingModals.paywall.autoZoom.preview.badge': 'Zoom automático',
  'recordingModals.paywall.autoZoom.preview.cta': 'Empezar',
  'recordingModals.paywall.autoZoom.strip': 'Grabaciones de pantalla con acabado de demo profesional.',
  'recordingModals.paywall.autoZoom.title': 'Zoom dinámico, añadido para ti',
  'recordingModals.paywall.choosePlan': 'Elegir plan',
  'recordingModals.paywall.closeAria': 'Cerrar la ventana de planes',
  'recordingModals.paywall.download.badge': 'DISPONIBLE EN TODOS LOS PLANES',
  'recordingModals.paywall.download.bullet1': 'Demo completa en alta calidad',
  'recordingModals.paywall.download.bullet2': 'Exporta un MP4 limpio, solo con tu marca',
  'recordingModals.paywall.download.bullet3': 'Publícala donde quieras o envía el archivo a tu equipo',
  'recordingModals.paywall.download.description':
    'Con un plan de pago exportas tu demo terminada en máxima calidad, lista para publicar y compartir.',
  'recordingModals.paywall.download.preview.alt': 'Vista previa de la demo en vídeo',
  'recordingModals.paywall.download.preview.button': 'Descargar vídeo',
  'recordingModals.paywall.download.strip': 'El resultado completo: exactamente lo que creaste.',
  'recordingModals.paywall.download.title': 'Tu demo está lista.\nDescárgala completa',
  'recordingModals.paywall.recordingMinutes.badge': 'GRABACIÓN GRATUITA UTILIZADA',
  'recordingModals.paywall.recordingMinutes.bullet1': 'Graba todas las demos que necesites',
  'recordingModals.paywall.recordingMinutes.bullet2': 'Deja que la IA pula cada grabación',
  'recordingModals.paywall.recordingMinutes.bullet3': 'Añade un zoom dinámico que sigue la acción',
  'recordingModals.paywall.recordingMinutes.description':
    'Ya has usado tu grabación gratuita. Mejora tu plan para seguir grabando demos de producto sin límite, pulidas con IA.',
  'recordingModals.paywall.recordingMinutes.preview.rec': 'REC {time}',
  'recordingModals.paywall.recordingMinutes.strip': 'Demos ilimitadas, de principio a fin.',
  'recordingModals.paywall.recordingMinutes.title': 'Sigue convirtiendo tu pantalla en demos impecables',
  'recordingModals.paywall.translateMinutes.badge': 'MEJORA TU PLAN PARA TENER MÁS MINUTOS',
  'recordingModals.paywall.translateMinutes.bullet1': 'Dirígete a tu público en más de 135 idiomas',
  'recordingModals.paywall.translateMinutes.bullet2': 'Conserva tu propia voz en cada idioma',
  'recordingModals.paywall.translateMinutes.bullet3': 'Convierte un vídeo en una biblioteca de versiones localizadas',
  'recordingModals.paywall.translateMinutes.description':
    'Mejora tu plan para seguir traduciendo tus vídeos a más de 135 idiomas con voces naturales, como las de hablantes nativos.',
  'recordingModals.paywall.translateMinutes.preview.caption': 'Traduciendo el vídeo de demostración',
  'recordingModals.paywall.translateMinutes.strip': 'Un vídeo, listo para cada mercado.',
  'recordingModals.paywall.translateMinutes.title': 'Llega a todos los públicos en su idioma',
  'recordingModals.recorder.ariaLabel': 'Grabador de pantalla',
  'recordingModals.recorder.camera': 'Cámara',
  'recordingModals.recorder.cameraFallback': 'Cámara {index}',
  'recordingModals.recorder.cameraUnavailable': 'La cámara no está disponible. Se grabará sin cámara.',
  'recordingModals.recorder.close': 'Cerrar el grabador',
  'recordingModals.recorder.defaultTitle': 'Grabación de pantalla {date}',
  'recordingModals.recorder.delete.cancel': 'Cancelar',
  'recordingModals.recorder.delete.closeAria': 'Cerrar la confirmación de eliminación',
  'recordingModals.recorder.delete.confirm': 'Eliminar',
  'recordingModals.recorder.delete.description': 'La grabación no se guardará. Puedes empezar de nuevo cuando quieras.',
  'recordingModals.recorder.delete.title': '¿Eliminar esta grabación?',
  'recordingModals.recorder.desktopOnly': 'La grabación de pantalla solo está disponible en ordenador',
  'recordingModals.recorder.discard': 'Descartar grabación',
  'recordingModals.recorder.duration': 'Tiempo de grabación',
  'recordingModals.recorder.error.cancelled':
    'Se canceló el uso compartido de pantalla. Elige una pantalla, ventana o pestaña para empezar a grabar.',
  'recordingModals.recorder.error.generic': 'No se pudo iniciar la grabación de pantalla. Inténtalo de nuevo.',
  'recordingModals.recorder.error.sharingEnded':
    'El uso compartido de pantalla terminó antes de que pudiera empezar la grabación. Inténtalo de nuevo.',
  'recordingModals.recorder.microphone': 'Micrófono',
  'recordingModals.recorder.microphoneFallback': 'Micrófono {index}',
  'recordingModals.recorder.microphoneUnavailable': 'El micrófono no está disponible. Se grabará sin micrófono.',
  'recordingModals.recorder.noCamera': 'Sin cámara',
  'recordingModals.recorder.noCameraOption': 'No usar la cámara',
  'recordingModals.recorder.noMicrophone': 'Sin micrófono',
  'recordingModals.recorder.noMicrophoneOption': 'No usar el micrófono',
  'recordingModals.recorder.pause': 'Pausar grabación',
  'recordingModals.recorder.reconnecting': 'Reconectando…',
  'recordingModals.recorder.record': 'Grabar',
  'recordingModals.recorder.resume': 'Reanudar grabación',
  'recordingModals.recorder.saveFailed.accessDenied':
    'Ahora mismo no puedes guardar grabaciones en este Teamspace. Pide a su propietario que revise el plan y tu acceso.',
  'recordingModals.recorder.saveFailed.autoStopped':
    'La grabación se detuvo porque no se pudo subir. Lo que grabaste hasta ahora se conserva, así que puedes volver a intentar guardarla.',
  'recordingModals.recorder.saveFailed.delete': 'Eliminar',
  'recordingModals.recorder.saveFailed.retry': 'Reintentar',
  'recordingModals.recorder.saveFailed.title': 'No se pudo guardar la grabación',
  'recordingModals.recorder.saving': 'Guardando grabación…',
  'recordingModals.recorder.stop': 'Detener grabación',
  'recordingModals.share.button': 'Compartir',
  'recordingModals.share.closeAria': 'Cerrar la ventana para compartir',
  'recordingModals.share.copy': 'Copiar',
  'recordingModals.share.description': 'Copia el enlace y envíaselo a quien quieras.',
  'recordingModals.share.linkAria': 'Enlace para compartir',
  'recordingModals.share.linkCopied': 'Enlace copiado al portapapeles',
  'recordingModals.share.title': 'Tu demo está lista para compartir',
  'recordingModals.share.upsell': 'Comparte demos completas y sin marca de agua',
} satisfies RecordingModalsTranslation;

const pt = {
  'recordingModals.extension.banner.description':
    'Grave direto do seu navegador sem abrir o Rask e tenha zoom automático dinâmico em cada clique.',
  'recordingModals.extension.banner.title': 'Grave ainda mais rápido com a extensão do Rask',
  'recordingModals.extension.closeAria': 'Fechar a configuração da extensão',
  'recordingModals.extension.install.addToChrome': 'Usar no Chrome',
  'recordingModals.extension.install.cardKind': 'Extensão do Chrome',
  'recordingModals.extension.install.cta': 'Instalar extensão',
  'recordingModals.extension.install.description':
    'O zoom automático é aplicado enquanto você grava. Instale a extensão do Rask para Chrome para ativá-lo.',
  'recordingModals.extension.install.title': 'Instale a extensão para ter zoom automático',
  'recordingModals.extension.pin.cta': 'Gravar vídeo',
  'recordingModals.extension.pin.description':
    'Clique no ícone de fixar para manter o Rask na barra de ferramentas e depois clique no ícone do Rask para abri-lo e começar a gravar — o zoom automático acompanha seus cliques.',
  'recordingModals.extension.pin.extensions': 'Extensões',
  'recordingModals.extension.pin.installed': 'Extensão instalada',
  'recordingModals.extension.pin.title': 'Fixe o Rask para acessá-lo depois',
  'recordingModals.extension.recorderName': 'Rask Screen Recorder',
  'recordingModals.intro.paid.description':
    'Grave sua tela e transformaremos a gravação em uma demo de produto impecável, removendo os vícios de linguagem, as pausas e as hesitações para você.',
  'recordingModals.intro.trial.badge': 'TESTE · 1 VÍDEO GRÁTIS',
  'recordingModals.intro.trial.description':
    'Grave sua tela e transformaremos a gravação em uma demo de produto impecável, removendo os vícios de linguagem, as pausas e as hesitações para você. Seu teste inclui 1 vídeo de até {minutes} minutos.',
  'recordingModals.paywall.autoZoom.badge': 'DISPONÍVEL EM TODOS OS PLANOS',
  'recordingModals.paywall.autoZoom.bullet1': 'Leve o público direto ao recurso que você está mostrando',
  'recordingModals.paywall.autoZoom.bullet2': 'Deixe pequenos detalhes da interface nítidos em qualquer tela',
  'recordingModals.paywall.autoZoom.bullet3': 'Destaque cada clique para que nada passe despercebido',
  'recordingModals.paywall.autoZoom.description':
    'O Rask dá zoom em cada clique automaticamente. Sua demo fica com cara de produção profissional, e o público sempre olha para o que importa.',
  'recordingModals.paywall.autoZoom.preview.badge': 'Zoom automático',
  'recordingModals.paywall.autoZoom.preview.cta': 'Começar',
  'recordingModals.paywall.autoZoom.strip': 'Gravações de tela com cara de demo profissional.',
  'recordingModals.paywall.autoZoom.title': 'Zoom dinâmico, adicionado para você',
  'recordingModals.paywall.choosePlan': 'Escolher plano',
  'recordingModals.paywall.closeAria': 'Fechar janela de planos',
  'recordingModals.paywall.download.badge': 'DISPONÍVEL EM TODOS OS PLANOS',
  'recordingModals.paywall.download.bullet1': 'Demo completa em alta qualidade',
  'recordingModals.paywall.download.bullet2': 'Exporte um MP4 limpo, só com a sua marca',
  'recordingModals.paywall.download.bullet3': 'Publique onde quiser ou envie o arquivo para sua equipe',
  'recordingModals.paywall.download.description':
    'Com um plano pago, você exporta sua demo finalizada em qualidade máxima, pronta para publicar e compartilhar.',
  'recordingModals.paywall.download.preview.alt': 'Prévia da demo em vídeo',
  'recordingModals.paywall.download.preview.button': 'Baixar vídeo',
  'recordingModals.paywall.download.strip': 'O resultado completo — exatamente o que você criou.',
  'recordingModals.paywall.download.title': 'Sua demo está pronta.\nBaixe a versão completa',
  'recordingModals.paywall.recordingMinutes.badge': 'GRAVAÇÃO GRATUITA JÁ UTILIZADA',
  'recordingModals.paywall.recordingMinutes.bullet1': 'Grave quantas demos precisar',
  'recordingModals.paywall.recordingMinutes.bullet2': 'Deixe a IA refinar cada gravação',
  'recordingModals.paywall.recordingMinutes.bullet3': 'Adicione um zoom dinâmico que acompanha a ação',
  'recordingModals.paywall.recordingMinutes.description':
    'Você já usou sua gravação gratuita. Faça upgrade para continuar e gravar demos de produto ilimitadas, refinadas por IA.',
  'recordingModals.paywall.recordingMinutes.preview.rec': 'REC {time}',
  'recordingModals.paywall.recordingMinutes.strip': 'Demos ilimitadas, do início ao fim.',
  'recordingModals.paywall.recordingMinutes.title': 'Continue transformando sua tela em demos impecáveis',
  'recordingModals.paywall.translateMinutes.badge': 'FAÇA UPGRADE PARA TER MAIS MINUTOS',
  'recordingModals.paywall.translateMinutes.bullet1': 'Fale com o público em mais de 135 idiomas',
  'recordingModals.paywall.translateMinutes.bullet2': 'Mantenha sua própria voz em todos os idiomas',
  'recordingModals.paywall.translateMinutes.bullet3': 'Transforme um vídeo em uma biblioteca de versões localizadas',
  'recordingModals.paywall.translateMinutes.description':
    'Faça upgrade para continuar traduzindo seus vídeos para mais de 135 idiomas, com vozes naturais que soam nativas.',
  'recordingModals.paywall.translateMinutes.preview.caption': 'Traduzindo o vídeo de demonstração',
  'recordingModals.paywall.translateMinutes.strip': 'Um vídeo, pronto para todos os mercados.',
  'recordingModals.paywall.translateMinutes.title': 'Alcance cada público no próprio idioma',
  'recordingModals.recorder.ariaLabel': 'Gravador de tela',
  'recordingModals.recorder.camera': 'Câmera',
  'recordingModals.recorder.cameraFallback': 'Câmera {index}',
  'recordingModals.recorder.cameraUnavailable': 'A câmera não está disponível. Gravando sem câmera.',
  'recordingModals.recorder.close': 'Fechar gravador',
  'recordingModals.recorder.defaultTitle': 'Gravação de tela {date}',
  'recordingModals.recorder.delete.cancel': 'Cancelar',
  'recordingModals.recorder.delete.closeAria': 'Fechar confirmação de exclusão',
  'recordingModals.recorder.delete.confirm': 'Excluir',
  'recordingModals.recorder.delete.description': 'A gravação não será salva. Você pode começar de novo quando quiser.',
  'recordingModals.recorder.delete.title': 'Excluir esta gravação?',
  'recordingModals.recorder.desktopOnly': 'A gravação de tela só está disponível no computador',
  'recordingModals.recorder.discard': 'Descartar gravação',
  'recordingModals.recorder.duration': 'Tempo de gravação',
  'recordingModals.recorder.error.cancelled':
    'O compartilhamento de tela foi cancelado. Escolha uma tela, janela ou aba para começar a gravar.',
  'recordingModals.recorder.error.generic': 'Não foi possível iniciar a gravação de tela. Tente novamente.',
  'recordingModals.recorder.error.sharingEnded':
    'O compartilhamento de tela terminou antes de a gravação começar. Tente novamente.',
  'recordingModals.recorder.microphone': 'Microfone',
  'recordingModals.recorder.microphoneFallback': 'Microfone {index}',
  'recordingModals.recorder.microphoneUnavailable': 'O microfone não está disponível. Gravando sem microfone.',
  'recordingModals.recorder.noCamera': 'Sem câmera',
  'recordingModals.recorder.noCameraOption': 'Não usar a câmera',
  'recordingModals.recorder.noMicrophone': 'Sem microfone',
  'recordingModals.recorder.noMicrophoneOption': 'Não usar o microfone',
  'recordingModals.recorder.pause': 'Pausar gravação',
  'recordingModals.recorder.reconnecting': 'Reconectando…',
  'recordingModals.recorder.record': 'Gravar',
  'recordingModals.recorder.resume': 'Retomar gravação',
  'recordingModals.recorder.saveFailed.accessDenied':
    'No momento, você não pode salvar gravações neste Teamspace. Peça ao proprietário para verificar o plano e o seu acesso.',
  'recordingModals.recorder.saveFailed.autoStopped':
    'A gravação foi interrompida porque não foi possível enviá-la. O que você gravou até agora foi mantido, então você pode tentar salvar de novo.',
  'recordingModals.recorder.saveFailed.delete': 'Excluir',
  'recordingModals.recorder.saveFailed.retry': 'Tentar novamente',
  'recordingModals.recorder.saveFailed.title': 'Não foi possível salvar a gravação',
  'recordingModals.recorder.saving': 'Salvando gravação…',
  'recordingModals.recorder.stop': 'Parar gravação',
  'recordingModals.share.button': 'Compartilhar',
  'recordingModals.share.closeAria': 'Fechar janela de compartilhamento',
  'recordingModals.share.copy': 'Copiar',
  'recordingModals.share.description': 'Copie o link e envie para quem quiser.',
  'recordingModals.share.linkAria': 'Link de compartilhamento',
  'recordingModals.share.linkCopied': 'Link copiado para a área de transferência',
  'recordingModals.share.title': 'Sua demo está pronta para ser compartilhada',
  'recordingModals.share.upsell': 'Compartilhe demos completas e sem marca d’água',
} satisfies RecordingModalsTranslation;

const fr = {
  'recordingModals.extension.banner.description':
    'Enregistrez directement depuis votre navigateur sans ouvrir Rask et profitez d’un zoom automatique dynamique à chaque clic.',
  'recordingModals.extension.banner.title': 'Enregistrez encore plus vite avec l’extension Rask',
  'recordingModals.extension.closeAria': 'Fermer la configuration de l’extension',
  'recordingModals.extension.install.addToChrome': 'Ajouter à Chrome',
  'recordingModals.extension.install.cardKind': 'Extension Chrome',
  'recordingModals.extension.install.cta': 'Installer l’extension',
  'recordingModals.extension.install.description':
    'Les zooms automatiques sont ajoutés pendant l’enregistrement. Installez l’extension Chrome de Rask pour les activer.',
  'recordingModals.extension.install.title': 'Installez l’extension pour profiter des zooms automatiques',
  'recordingModals.extension.pin.cta': 'Enregistrer une vidéo',
  'recordingModals.extension.pin.description':
    'Cliquez sur l’épingle pour garder Rask dans votre barre d’outils, puis cliquez sur l’icône Rask pour l’ouvrir et lancer l’enregistrement : les zooms automatiques suivent vos clics.',
  'recordingModals.extension.pin.extensions': 'Extensions',
  'recordingModals.extension.pin.installed': 'Extension installée',
  'recordingModals.extension.pin.title': 'Épinglez Rask pour y accéder plus tard',
  'recordingModals.extension.recorderName': 'Rask Screen Recorder',
  'recordingModals.intro.paid.description':
    'Enregistrez votre écran et nous transformerons l’enregistrement en une démo produit soignée, en supprimant pour vous les mots parasites, les pauses et les hésitations.',
  'recordingModals.intro.trial.badge': 'ESSAI · 1 VIDÉO GRATUITE',
  'recordingModals.intro.trial.description':
    'Enregistrez votre écran et nous transformerons l’enregistrement en une démo produit soignée, en supprimant pour vous les mots parasites, les pauses et les hésitations. Votre essai comprend 1 vidéo de {minutes} minutes maximum.',
  'recordingModals.paywall.autoZoom.badge': 'DISPONIBLE AVEC TOUS LES FORFAITS',
  'recordingModals.paywall.autoZoom.bullet1': 'Guidez le regard vers la fonctionnalité que vous présentez',
  'recordingModals.paywall.autoZoom.bullet2':
    'Rendez les petits détails de l’interface bien visibles sur tous les écrans',
  'recordingModals.paywall.autoZoom.bullet3': 'Mettez chaque clic en valeur pour que rien ne passe inaperçu',
  'recordingModals.paywall.autoZoom.description':
    'Rask zoome automatiquement sur chaque clic. Votre démo a un rendu professionnel, et le regard va toujours à l’essentiel.',
  'recordingModals.paywall.autoZoom.preview.badge': 'Zoom auto',
  'recordingModals.paywall.autoZoom.preview.cta': 'Commencer',
  'recordingModals.paywall.autoZoom.strip': 'Des enregistrements d’écran dignes d’une démo professionnelle.',
  'recordingModals.paywall.autoZoom.title': 'Zoom dynamique, ajouté pour vous',
  'recordingModals.paywall.choosePlan': 'Choisir un forfait',
  'recordingModals.paywall.closeAria': 'Fermer la fenêtre des forfaits',
  'recordingModals.paywall.download.badge': 'DISPONIBLE AVEC TOUS LES FORFAITS',
  'recordingModals.paywall.download.bullet1': 'Démo complète en haute qualité',
  'recordingModals.paywall.download.bullet2': 'Exportez un MP4 sans marque Rask, entièrement à votre image',
  'recordingModals.paywall.download.bullet3': 'Publiez-la où vous voulez ou envoyez le fichier à votre équipe',
  'recordingModals.paywall.download.description':
    'Avec un forfait payant, exportez votre démo finale en qualité optimale, prête à être publiée et partagée.',
  'recordingModals.paywall.download.preview.alt': 'Aperçu de la démo vidéo',
  'recordingModals.paywall.download.preview.button': 'Télécharger la vidéo',
  'recordingModals.paywall.download.strip': 'Le résultat complet, exactement ce que vous avez créé.',
  'recordingModals.paywall.download.title': 'Votre démo est prête.\nTéléchargez-la en entier',
  'recordingModals.paywall.recordingMinutes.badge': 'ENREGISTREMENT GRATUIT DÉJÀ UTILISÉ',
  'recordingModals.paywall.recordingMinutes.bullet1': 'Enregistrez autant de démos que nécessaire',
  'recordingModals.paywall.recordingMinutes.bullet2': 'Laissez l’IA peaufiner chaque enregistrement',
  'recordingModals.paywall.recordingMinutes.bullet3': 'Ajoutez un zoom dynamique qui suit l’action',
  'recordingModals.paywall.recordingMinutes.description':
    'Vous avez utilisé votre enregistrement gratuit. Passez à un forfait supérieur pour continuer et enregistrer un nombre illimité de démos de produit, peaufinées par l’IA.',
  'recordingModals.paywall.recordingMinutes.preview.rec': 'REC {time}',
  'recordingModals.paywall.recordingMinutes.strip': 'Des démos illimitées, du début à la fin.',
  'recordingModals.paywall.recordingMinutes.title':
    'Continuez à transformer vos enregistrements d’écran en démos soignées',
  'recordingModals.paywall.translateMinutes.badge': 'PLUS DE MINUTES AVEC UN FORFAIT SUPÉRIEUR',
  'recordingModals.paywall.translateMinutes.bullet1': 'Adressez-vous à votre public en plus de 135 langues',
  'recordingModals.paywall.translateMinutes.bullet2': 'Gardez votre propre voix dans chaque langue',
  'recordingModals.paywall.translateMinutes.bullet3':
    'Transformez une vidéo en une bibliothèque de versions adaptées à chaque langue',
  'recordingModals.paywall.translateMinutes.description':
    'Passez à un forfait supérieur pour continuer à traduire vos vidéos en plus de 135 langues, avec des voix naturelles comme celles de locuteurs natifs.',
  'recordingModals.paywall.translateMinutes.preview.caption': 'Traduction de la vidéo de démo',
  'recordingModals.paywall.translateMinutes.strip': 'Une vidéo, prête pour chaque marché.',
  'recordingModals.paywall.translateMinutes.title': 'Touchez tous les publics dans leur langue',
  'recordingModals.recorder.ariaLabel': 'Enregistreur d’écran',
  'recordingModals.recorder.camera': 'Caméra',
  'recordingModals.recorder.cameraFallback': 'Caméra {index}',
  'recordingModals.recorder.cameraUnavailable': 'Caméra indisponible. Enregistrement sans caméra.',
  'recordingModals.recorder.close': 'Fermer l’enregistreur',
  'recordingModals.recorder.defaultTitle': 'Enregistrement d’écran {date}',
  'recordingModals.recorder.delete.cancel': 'Annuler',
  'recordingModals.recorder.delete.closeAria': 'Fermer la confirmation de suppression',
  'recordingModals.recorder.delete.confirm': 'Supprimer',
  'recordingModals.recorder.delete.description':
    'L’enregistrement ne sera pas conservé. Vous pouvez recommencer à tout moment.',
  'recordingModals.recorder.delete.title': 'Supprimer cet enregistrement ?',
  'recordingModals.recorder.desktopOnly': 'L’enregistrement d’écran est disponible uniquement sur ordinateur',
  'recordingModals.recorder.discard': 'Supprimer l’enregistrement',
  'recordingModals.recorder.duration': 'Durée de l’enregistrement',
  'recordingModals.recorder.error.cancelled':
    'Le partage d’écran a été annulé. Choisissez un écran, une fenêtre ou un onglet pour commencer l’enregistrement.',
  'recordingModals.recorder.error.generic': 'Impossible de démarrer l’enregistrement d’écran. Veuillez réessayer.',
  'recordingModals.recorder.error.sharingEnded':
    'Le partage d’écran s’est arrêté avant le début de l’enregistrement. Veuillez réessayer.',
  'recordingModals.recorder.microphone': 'Micro',
  'recordingModals.recorder.microphoneFallback': 'Micro {index}',
  'recordingModals.recorder.microphoneUnavailable': 'Micro indisponible. Enregistrement sans micro.',
  'recordingModals.recorder.noCamera': 'Sans caméra',
  'recordingModals.recorder.noCameraOption': 'Ne pas utiliser la caméra',
  'recordingModals.recorder.noMicrophone': 'Sans micro',
  'recordingModals.recorder.noMicrophoneOption': 'Ne pas utiliser le micro',
  'recordingModals.recorder.pause': 'Mettre en pause',
  'recordingModals.recorder.reconnecting': 'Reconnexion…',
  'recordingModals.recorder.record': 'Enregistrer',
  'recordingModals.recorder.resume': 'Reprendre l’enregistrement',
  'recordingModals.recorder.saveFailed.accessDenied':
    'Vous ne pouvez pas sauvegarder d’enregistrements dans ce Teamspace pour le moment. Demandez à son propriétaire de vérifier l’abonnement et votre accès.',
  'recordingModals.recorder.saveFailed.autoStopped':
    'L’enregistrement s’est arrêté, car il n’a pas pu être envoyé. Ce que vous avez enregistré jusqu’ici est conservé : vous pouvez réessayer de le sauvegarder.',
  'recordingModals.recorder.saveFailed.delete': 'Supprimer',
  'recordingModals.recorder.saveFailed.retry': 'Réessayer',
  'recordingModals.recorder.saveFailed.title': 'Impossible de sauvegarder l’enregistrement',
  'recordingModals.recorder.saving': 'Sauvegarde de l’enregistrement…',
  'recordingModals.recorder.stop': 'Arrêter l’enregistrement',
  'recordingModals.share.button': 'Partager',
  'recordingModals.share.closeAria': 'Fermer la fenêtre de partage',
  'recordingModals.share.copy': 'Copier',
  'recordingModals.share.description': 'Copiez le lien et envoyez-le à qui vous voulez.',
  'recordingModals.share.linkAria': 'Lien de partage',
  'recordingModals.share.linkCopied': 'Lien copié dans le presse-papiers',
  'recordingModals.share.title': 'Votre démo est prête à être partagée',
  'recordingModals.share.upsell': 'Partagez des démos complètes, sans filigrane',
} satisfies RecordingModalsTranslation;

const it = {
  'recordingModals.extension.banner.description':
    'Registra direttamente dal browser senza aprire Rask e ottieni lo zoom automatico dinamico a ogni clic.',
  'recordingModals.extension.banner.title': 'Registra ancora più velocemente con l’estensione Rask',
  'recordingModals.extension.closeAria': 'Chiudi la configurazione dell’estensione',
  'recordingModals.extension.install.addToChrome': 'Aggiungi a Chrome',
  'recordingModals.extension.install.cardKind': 'Estensione di Chrome',
  'recordingModals.extension.install.cta': 'Installa estensione',
  'recordingModals.extension.install.description':
    'Gli zoom automatici vengono aggiunti mentre registri. Installa l’estensione Rask per Chrome per attivarli.',
  'recordingModals.extension.install.title': 'Installa l’estensione per avere gli zoom automatici',
  'recordingModals.extension.pin.cta': 'Registra video',
  'recordingModals.extension.pin.description':
    'Fai clic sulla puntina per tenere Rask nella barra degli strumenti, poi fai clic sull’icona di Rask per aprirlo e iniziare a registrare: gli zoom automatici seguono i tuoi clic.',
  'recordingModals.extension.pin.extensions': 'Estensioni',
  'recordingModals.extension.pin.installed': 'Estensione installata',
  'recordingModals.extension.pin.title': 'Fissa Rask per ritrovarlo facilmente',
  'recordingModals.extension.recorderName': 'Rask Screen Recorder',
  'recordingModals.intro.paid.description':
    'Registra lo schermo e trasformeremo la registrazione in una demo di prodotto curata, tagliando per te intercalari, pause ed esitazioni.',
  'recordingModals.intro.trial.badge': 'PROVA · 1 VIDEO GRATIS',
  'recordingModals.intro.trial.description':
    'Registra lo schermo e trasformeremo la registrazione in una demo di prodotto curata, tagliando per te intercalari, pause ed esitazioni. La tua prova include 1 video, fino a {minutes} minuti.',
  'recordingModals.paywall.autoZoom.badge': 'DISPONIBILE CON TUTTI I PIANI',
  'recordingModals.paywall.autoZoom.bullet1': 'Porta lo sguardo dritto sulla funzione che stai mostrando',
  'recordingModals.paywall.autoZoom.bullet2': 'Rendi chiari i piccoli dettagli dell’interfaccia su qualsiasi schermo',
  'recordingModals.paywall.autoZoom.bullet3': 'Evidenzia ogni clic, così non sfugge nulla',
  'recordingModals.paywall.autoZoom.description':
    'Rask fa zoom su ogni clic in automatico. La tua demo sembra prodotta da professionisti e chi guarda punta sempre dove conta.',
  'recordingModals.paywall.autoZoom.preview.badge': 'Zoom automatico',
  'recordingModals.paywall.autoZoom.preview.cta': 'Inizia',
  'recordingModals.paywall.autoZoom.strip': 'Registrazioni dello schermo che sembrano demo professionali.',
  'recordingModals.paywall.autoZoom.title': 'Zoom dinamico, aggiunto per te',
  'recordingModals.paywall.choosePlan': 'Scegli un piano',
  'recordingModals.paywall.closeAria': 'Chiudi la finestra dei piani',
  'recordingModals.paywall.download.badge': 'DISPONIBILE CON TUTTI I PIANI',
  'recordingModals.paywall.download.bullet1': 'Demo completa in alta qualità',
  'recordingModals.paywall.download.bullet2': 'Esporta un MP4 pulito, interamente con il tuo brand',
  'recordingModals.paywall.download.bullet3': 'Pubblica ovunque o invia il file al tuo team',
  'recordingModals.paywall.download.description':
    'Con un piano a pagamento esporti la tua demo finita in piena qualità, pronta da pubblicare e condividere.',
  'recordingModals.paywall.download.preview.alt': 'Anteprima della demo video',
  'recordingModals.paywall.download.preview.button': 'Scarica video',
  'recordingModals.paywall.download.strip': 'Il risultato completo, esattamente ciò che hai creato.',
  'recordingModals.paywall.download.title': 'La tua demo è pronta.\nScaricala per intero',
  'recordingModals.paywall.recordingMinutes.badge': 'REGISTRAZIONE GRATUITA UTILIZZATA',
  'recordingModals.paywall.recordingMinutes.bullet1': 'Registra tutte le demo che ti servono',
  'recordingModals.paywall.recordingMinutes.bullet2': 'Lascia che l’IA rifinisca ogni registrazione',
  'recordingModals.paywall.recordingMinutes.bullet3': 'Aggiungi uno zoom dinamico che segue l’azione',
  'recordingModals.paywall.recordingMinutes.description':
    'Hai già usato la tua registrazione gratuita. Passa a un piano superiore per continuare e registrare demo di prodotto illimitate, rifinite dall’IA.',
  'recordingModals.paywall.recordingMinutes.preview.rec': 'REC {time}',
  'recordingModals.paywall.recordingMinutes.strip': 'Demo illimitate, dall’inizio alla fine.',
  'recordingModals.paywall.recordingMinutes.title': 'Continua a trasformare il tuo schermo in demo curate',
  'recordingModals.paywall.translateMinutes.badge': 'PASSA A UN PIANO SUPERIORE PER PIÙ MINUTI',
  'recordingModals.paywall.translateMinutes.bullet1': 'Parla al tuo pubblico in oltre 135 lingue',
  'recordingModals.paywall.translateMinutes.bullet2': 'Mantieni la tua voce in ogni lingua',
  'recordingModals.paywall.translateMinutes.bullet3': 'Trasforma un video in una libreria di versioni localizzate',
  'recordingModals.paywall.translateMinutes.description':
    'Passa a un piano superiore per continuare a tradurre i tuoi video in oltre 135 lingue con voci naturali, come quelle di madrelingua.',
  'recordingModals.paywall.translateMinutes.preview.caption': 'Traduzione del video demo',
  'recordingModals.paywall.translateMinutes.strip': 'Un video, pronto per ogni mercato.',
  'recordingModals.paywall.translateMinutes.title': 'Raggiungi ogni pubblico nella sua lingua',
  'recordingModals.recorder.ariaLabel': 'Registratore dello schermo',
  'recordingModals.recorder.camera': 'Videocamera',
  'recordingModals.recorder.cameraFallback': 'Videocamera {index}',
  'recordingModals.recorder.cameraUnavailable': 'Videocamera non disponibile. Registrazione senza videocamera.',
  'recordingModals.recorder.close': 'Chiudi registratore',
  'recordingModals.recorder.defaultTitle': 'Registrazione dello schermo {date}',
  'recordingModals.recorder.delete.cancel': 'Annulla',
  'recordingModals.recorder.delete.closeAria': 'Chiudi conferma di eliminazione',
  'recordingModals.recorder.delete.confirm': 'Elimina',
  'recordingModals.recorder.delete.description': 'La registrazione non verrà salvata. Puoi ricominciare quando vuoi.',
  'recordingModals.recorder.delete.title': 'Eliminare questa registrazione?',
  'recordingModals.recorder.desktopOnly': 'La registrazione dello schermo è disponibile solo da computer',
  'recordingModals.recorder.discard': 'Scarta registrazione',
  'recordingModals.recorder.duration': 'Durata della registrazione',
  'recordingModals.recorder.error.cancelled':
    'Condivisione dello schermo annullata. Scegli uno schermo, una finestra o una scheda per iniziare a registrare.',
  'recordingModals.recorder.error.generic': 'Impossibile avviare la registrazione dello schermo. Riprova.',
  'recordingModals.recorder.error.sharingEnded':
    'La condivisione dello schermo si è interrotta prima dell’inizio della registrazione. Riprova.',
  'recordingModals.recorder.microphone': 'Microfono',
  'recordingModals.recorder.microphoneFallback': 'Microfono {index}',
  'recordingModals.recorder.microphoneUnavailable': 'Microfono non disponibile. Registrazione senza microfono.',
  'recordingModals.recorder.noCamera': 'Senza videocamera',
  'recordingModals.recorder.noCameraOption': 'Non usare la videocamera',
  'recordingModals.recorder.noMicrophone': 'Senza microfono',
  'recordingModals.recorder.noMicrophoneOption': 'Non usare il microfono',
  'recordingModals.recorder.pause': 'Metti in pausa',
  'recordingModals.recorder.reconnecting': 'Riconnessione…',
  'recordingModals.recorder.record': 'Registra',
  'recordingModals.recorder.resume': 'Riprendi registrazione',
  'recordingModals.recorder.saveFailed.accessDenied':
    'Al momento non puoi salvare registrazioni in questo Teamspace. Chiedi al proprietario di controllare il piano e il tuo accesso.',
  'recordingModals.recorder.saveFailed.autoStopped':
    'La registrazione si è interrotta perché non è stato possibile caricarla. Quanto registrato finora è conservato: puoi riprovare a salvarla.',
  'recordingModals.recorder.saveFailed.delete': 'Elimina',
  'recordingModals.recorder.saveFailed.retry': 'Riprova',
  'recordingModals.recorder.saveFailed.title': 'Impossibile salvare la registrazione',
  'recordingModals.recorder.saving': 'Salvataggio della registrazione…',
  'recordingModals.recorder.stop': 'Interrompi registrazione',
  'recordingModals.share.button': 'Condividi',
  'recordingModals.share.closeAria': 'Chiudi la finestra di condivisione',
  'recordingModals.share.copy': 'Copia',
  'recordingModals.share.description': 'Copia il link e invialo a chi vuoi.',
  'recordingModals.share.linkAria': 'Link di condivisione',
  'recordingModals.share.linkCopied': 'Link copiato negli appunti',
  'recordingModals.share.title': 'La tua demo è pronta da condividere',
  'recordingModals.share.upsell': 'Condividi demo complete e senza filigrana',
} satisfies RecordingModalsTranslation;

const ru = {
  'recordingModals.extension.banner.description':
    'Записывайте прямо из браузера, не открывая Rask, и получайте динамический автозум при каждом клике.',
  'recordingModals.extension.banner.title': 'Записывайте ещё быстрее с расширением Rask',
  'recordingModals.extension.closeAria': 'Закрыть настройку расширения',
  'recordingModals.extension.install.addToChrome': 'Установить',
  'recordingModals.extension.install.cardKind': 'Расширение для Chrome',
  'recordingModals.extension.install.cta': 'Установить расширение',
  'recordingModals.extension.install.description':
    'Автозумы добавляются прямо во время записи. Установите расширение Rask для Chrome, чтобы включить их.',
  'recordingModals.extension.install.title': 'Установите расширение, чтобы включить автозумы',
  'recordingModals.extension.pin.cta': 'Записать видео',
  'recordingModals.extension.pin.description':
    'Нажмите на значок булавки, чтобы закрепить Rask на панели инструментов, затем нажмите на значок Rask, чтобы открыть его и начать запись — автозумы будут автоматически следовать за вашими кликами.',
  'recordingModals.extension.pin.extensions': 'Расширения',
  'recordingModals.extension.pin.installed': 'Расширение установлено',
  'recordingModals.extension.pin.title': 'Закрепите Rask, чтобы он был под рукой',
  'recordingModals.extension.recorderName': 'Rask Screen Recorder',
  'recordingModals.intro.paid.description':
    'Запишите экран, а мы превратим запись в профессиональное демо продукта: уберём слова-паразиты, паузы и запинки.',
  'recordingModals.intro.trial.badge': 'ПРОБНЫЙ ПЕРИОД · 1 БЕСПЛАТНОЕ ВИДЕО',
  'recordingModals.intro.trial.description':
    'Запишите экран, а мы превратим запись в профессиональное демо продукта: уберём слова-паразиты, паузы и запинки. В рамках пробного периода доступно 1 видео длительностью до {minutes} минут.',
  'recordingModals.paywall.autoZoom.badge': 'ДОСТУПНО НА ВСЕХ ТАРИФАХ',
  'recordingModals.paywall.autoZoom.bullet1': 'Направляйте внимание зрителей прямо на функцию, которую показываете',
  'recordingModals.paywall.autoZoom.bullet2': 'Мелкие детали интерфейса хорошо видны на любом экране',
  'recordingModals.paywall.autoZoom.bullet3': 'Каждый клик выделен — зрители ничего не пропустят',
  'recordingModals.paywall.autoZoom.description':
    'Rask автоматически приближает область вокруг каждого клика. Демо выглядит профессионально, а зрители смотрят именно туда, куда нужно.',
  'recordingModals.paywall.autoZoom.preview.badge': 'Автозум',
  'recordingModals.paywall.autoZoom.preview.cta': 'Начать',
  'recordingModals.paywall.autoZoom.strip': 'Записи экрана, которые смотрятся как профессиональное демо.',
  'recordingModals.paywall.autoZoom.title': 'Динамический зум — уже добавлен',
  'recordingModals.paywall.choosePlan': 'Выбрать план',
  'recordingModals.paywall.closeAria': 'Закрыть окно тарифов',
  'recordingModals.paywall.download.badge': 'ДОСТУПНО НА ВСЕХ ТАРИФАХ',
  'recordingModals.paywall.download.bullet1': 'Полное демо в высоком качестве',
  'recordingModals.paywall.download.bullet2': 'Экспортируйте MP4 без чужого брендинга — только с вашим',
  'recordingModals.paywall.download.bullet3': 'Публикуйте где угодно или отправьте файл команде',
  'recordingModals.paywall.download.description':
    'Платный тариф позволяет экспортировать готовое демо в полном качестве — его сразу можно публиковать и отправлять.',
  'recordingModals.paywall.download.preview.alt': 'Предпросмотр демо-видео',
  'recordingModals.paywall.download.preview.button': 'Скачать видео',
  'recordingModals.paywall.download.strip': 'Полный результат — именно то, что вы создали.',
  'recordingModals.paywall.download.title': 'Ваше демо готово.\nСкачайте его целиком',
  'recordingModals.paywall.recordingMinutes.badge': 'БЕСПЛАТНАЯ ЗАПИСЬ УЖЕ ИСПОЛЬЗОВАНА',
  'recordingModals.paywall.recordingMinutes.bullet1': 'Записывайте столько демо, сколько нужно',
  'recordingModals.paywall.recordingMinutes.bullet2': 'ИИ приведёт в порядок каждую запись',
  'recordingModals.paywall.recordingMinutes.bullet3':
    'Добавьте динамический зум, который следует за действиями на экране',
  'recordingModals.paywall.recordingMinutes.description':
    'Вы уже использовали бесплатную запись. Перейдите на тариф выше, чтобы продолжить и записывать сколько угодно демо продукта, которые ИИ обработает автоматически.',
  'recordingModals.paywall.recordingMinutes.preview.rec': 'REC {time}',
  'recordingModals.paywall.recordingMinutes.strip': 'Безлимитные демо от начала до конца.',
  'recordingModals.paywall.recordingMinutes.title': 'Продолжайте создавать профессиональные демо из записей экрана',
  'recordingModals.paywall.translateMinutes.badge': 'БОЛЬШЕ МИНУТ ПРИ ПОВЫШЕНИИ ТАРИФА',
  'recordingModals.paywall.translateMinutes.bullet1': 'Обращайтесь к зрителям на 135+ языках',
  'recordingModals.paywall.translateMinutes.bullet2': 'Сохраняйте свой голос на всех языках',
  'recordingModals.paywall.translateMinutes.bullet3': 'Превратите одно видео в библиотеку локализованных версий',
  'recordingModals.paywall.translateMinutes.description':
    'Перейдите на тариф выше, чтобы и дальше переводить свои видео на 135+ языков с естественными голосами, звучащими как у носителей языка.',
  'recordingModals.paywall.translateMinutes.preview.caption': 'Перевод демо-видео',
  'recordingModals.paywall.translateMinutes.strip': 'Одно видео — для любого рынка.',
  'recordingModals.paywall.translateMinutes.title': 'Охватите любую аудиторию на её языке',
  'recordingModals.recorder.ariaLabel': 'Панель записи экрана',
  'recordingModals.recorder.camera': 'Камера',
  'recordingModals.recorder.cameraFallback': 'Камера {index}',
  'recordingModals.recorder.cameraUnavailable': 'Камера недоступна. Запись идёт без камеры.',
  'recordingModals.recorder.close': 'Закрыть запись экрана',
  'recordingModals.recorder.defaultTitle': 'Запись экрана {date}',
  'recordingModals.recorder.delete.cancel': 'Отмена',
  'recordingModals.recorder.delete.closeAria': 'Закрыть подтверждение удаления',
  'recordingModals.recorder.delete.confirm': 'Удалить',
  'recordingModals.recorder.delete.description': 'Запись не сохранится. Начать заново можно в любой момент.',
  'recordingModals.recorder.delete.title': 'Удалить эту запись?',
  'recordingModals.recorder.desktopOnly': 'Запись экрана доступна только на компьютере',
  'recordingModals.recorder.discard': 'Удалить запись',
  'recordingModals.recorder.duration': 'Время записи',
  'recordingModals.recorder.error.cancelled':
    'Демонстрация экрана отменена. Выберите экран, окно или вкладку, чтобы начать запись.',
  'recordingModals.recorder.error.generic': 'Не удалось начать запись экрана. Попробуйте ещё раз.',
  'recordingModals.recorder.error.sharingEnded':
    'Демонстрация экрана завершилась до начала записи. Попробуйте ещё раз.',
  'recordingModals.recorder.microphone': 'Микрофон',
  'recordingModals.recorder.microphoneFallback': 'Микрофон {index}',
  'recordingModals.recorder.microphoneUnavailable': 'Микрофон недоступен. Запись идёт без микрофона.',
  'recordingModals.recorder.noCamera': 'Без камеры',
  'recordingModals.recorder.noCameraOption': 'Не записывать камеру',
  'recordingModals.recorder.noMicrophone': 'Без микрофона',
  'recordingModals.recorder.noMicrophoneOption': 'Не записывать микрофон',
  'recordingModals.recorder.pause': 'Приостановить запись',
  'recordingModals.recorder.reconnecting': 'Переподключение…',
  'recordingModals.recorder.record': 'Записать',
  'recordingModals.recorder.resume': 'Продолжить запись',
  'recordingModals.recorder.saveFailed.accessDenied':
    'Сейчас нельзя сохранять записи в этом пространстве. Попросите его владельца проверить тариф и ваш доступ.',
  'recordingModals.recorder.saveFailed.autoStopped':
    'Запись остановлена: её не удалось загрузить. Записанное до этого момента не потеряно — попробуйте сохранить ещё раз.',
  'recordingModals.recorder.saveFailed.delete': 'Удалить',
  'recordingModals.recorder.saveFailed.retry': 'Повторить',
  'recordingModals.recorder.saveFailed.title': 'Не удалось сохранить запись',
  'recordingModals.recorder.saving': 'Сохраняем запись…',
  'recordingModals.recorder.stop': 'Остановить запись',
  'recordingModals.share.button': 'Поделиться',
  'recordingModals.share.closeAria': 'Закрыть окно «Поделиться»',
  'recordingModals.share.copy': 'Копировать',
  'recordingModals.share.description': 'Скопируйте ссылку и отправьте её кому угодно.',
  'recordingModals.share.linkAria': 'Ссылка для просмотра',
  'recordingModals.share.linkCopied': 'Ссылка скопирована в буфер обмена',
  'recordingModals.share.title': 'Вашим демо уже можно поделиться',
  'recordingModals.share.upsell': 'Делитесь полными демо без водяного знака',
} satisfies RecordingModalsTranslation;

export const RECORDING_MODALS_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
